(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurivita-reviews-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('aur-reviews-slider')) return;

    class AurReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-aur-track]');
        if (!this.track) return;

        this.dotsWrap = this.querySelector('[data-aur-dots]');
        this.prevBtn = this.querySelector('[data-aur-prev]');
        this.nextBtn = this.querySelector('[data-aur-next]');
        this.cards = Array.from(this.track.children);
        this.dots = this.dotsWrap ? Array.from(this.dotsWrap.children) : [];

        this.handleScroll = this.handleScroll.bind(this);
        this.update = this.update.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handlePrev = () => this.step(-1);
        this.handleNext = () => this.step(1);

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.prevBtn) this.prevBtn.addEventListener('click', this.handlePrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.handleNext);

        this.dotHandlers = this.dots.map((dot, i) => {
          const fn = () => this.goTo(i);
          dot.addEventListener('click', fn);
          return fn;
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.update);
        }

        this.update();
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.handleScroll);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);
        this.dots.forEach((dot, i) => dot.removeEventListener('click', this.dotHandlers[i]));
        if (this.resizeObserver) this.resizeObserver.disconnect();
        else window.removeEventListener('resize', this.update);
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      isScrollable() {
        return this.maxScroll() > 2;
      }

      update() {
        const scrollable = this.isScrollable();
        if (this.dotsWrap) this.dotsWrap.hidden = !scrollable;
        if (this.prevBtn) this.prevBtn.hidden = !scrollable;
        if (this.nextBtn) this.nextBtn.hidden = !scrollable;
        this.handleScroll();
      }

      offsetOf(index) {
        return this.cards[index].offsetLeft - this.cards[0].offsetLeft;
      }

      handleScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          const left = this.track.scrollLeft;
          const max = this.maxScroll();
          let index = 0;

          if (max > 0 && left >= max - 2) {
            index = this.cards.length - 1;
          } else {
            let closest = Infinity;
            this.cards.forEach((card, i) => {
              const dist = Math.abs(this.offsetOf(i) - left);
              if (dist < closest) {
                closest = dist;
                index = i;
              }
            });
          }

          this.setActive(index);

          if (this.prevBtn) this.prevBtn.disabled = left <= 2;
          if (this.nextBtn) this.nextBtn.disabled = left >= max - 2;
        });
      }

      setActive(index) {
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      step(direction) {
        const left = this.track.scrollLeft;
        let target = null;

        if (direction > 0) {
          for (let i = 0; i < this.cards.length; i++) {
            if (this.offsetOf(i) > left + 2) {
              target = i;
              break;
            }
          }
        } else {
          for (let i = this.cards.length - 1; i >= 0; i--) {
            if (this.offsetOf(i) < left - 2) {
              target = i;
              break;
            }
          }
        }

        if (target !== null) this.goTo(target);
      }

      goTo(index, instant) {
        if (!this.cards[index]) return;
        this.track.scrollTo({
          left: Math.min(this.offsetOf(index), this.maxScroll()),
          behavior: instant ? 'auto' : 'smooth'
        });
      }

      handleBlockSelect(event) {
        const card = event.target.closest('.aur-rv__card');
        const index = this.cards.indexOf(card);
        if (index > -1) this.goTo(index, !!event.detail && event.detail.load);
      }
    }

    customElements.define('aur-reviews-slider', AurReviewsSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-custom"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
